import { createFileRoute } from '@tanstack/react-router'
import { MachineRunEditor } from './-MachineRunEditor'

export const Route = createFileRoute('/production/machine-runs/$id')({
  component: MachineRunDetailPage,
})

function MachineRunDetailPage() {
  const { id } = Route.useParams()
  return <MachineRunEditor id={id} />
}
